import $ from 'jquery';

$(() => {
	$('.trigger-back').on('click', function (e) {
		history.back();
	});
});

